interface AuthConfig {
    domains: {
        [key: string]: string[];
    };
    getCookieDomain: () => string;
}

const authConfig: AuthConfig = {
    domains: {
        devPayroll: ['payroll.dev.veytan.com'],
        devApp: ['hcm.dev.veytan.com'],
        devAuth: ['auth.dev.veytan.com'],
        prodApp: ['hcm.veytan.com'],
        prodPayroll: ['payroll.veytan.com'],
        prodAuth: ['auth.veytan.com']
    },
    getCookieDomain: () => {
        // Env override — set REACT_APP_COOKIE_DOMAIN in .env.development.local
        // for non-standard local-dev layouts. Empty/unset = use the hostname
        // heuristic below.
        if (process.env.REACT_APP_COOKIE_DOMAIN) {
            return process.env.REACT_APP_COOKIE_DOMAIN;
        }

        const hostname = window.location.hostname;

        // Localhost: host-only cookie. Returning the hostname is safe even
        // if some future caller doesn't gate on isLocalhost (matches the
        // pattern used in vt-fe-hrms-01/src/lib/config/authConfig.ts).
        if (hostname === 'localhost' || hostname.match(/^(192\.168|127\.0)/)) {
            return hostname;
        }

        // For dev/staging environments - share cookies across dev subdomains
        if (hostname.includes('.dev')) {
            return '.dev.veytan.com';
        }

        // For production - share cookies across prod subdomains
        return '.veytan.com';
    }
};

export default authConfig; 